import './style.scss';
import { HamburgerMenu } from './hamburgerMenu';
import { HeaderMenu } from './headerMenu';
import { MainMenuProps, useMainMenu } from './hooks';
import { NavLink } from 'react-router-dom';
import { PagePath } from 'constants/pagePath';
import Logo from 'assets/logo_blue.svg';
import { ReactNode } from 'react';

export const Header = (props: { children?: ReactNode }) => {
  return (
    <header className="header">
      <NavLink to={PagePath.Root} className="header_logo">
        <img src={Logo} alt="Logo" />
      </NavLink>
      {props.children}
    </header>
  );
};

export const MainMenu = (props: MainMenuProps) => {
  const menuItems = useMainMenu(props);

  return (
    <Header>
      <div className="spHeader">
        <HamburgerMenu {...menuItems} />
      </div>
      <div className="pcHeader">
        <HeaderMenu {...menuItems} />
      </div>
    </Header>
  );
};
